var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['p-rated']},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.product.rating_html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }